import React from 'react';
import './tab.css';

const Tab = ({title, onClick, openedTab}) => {
  return (
    <button
      className={openedTab === title ? 'active tab' : 'tab'}
      onClick={onClick}
    >
      {title.toUpperCase()}
    </button>
  )
}
export default Tab